import { Alert, AlertTitle, Slide, Snackbar, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideMessageBar } from "../store/actions/MessageBarActions";

export default function AppMessageBar() {
  const dispatch = useDispatch();
  const messagebar = useSelector(({ MessageBar }) => MessageBar);
  const title = messagebar?.title || messagebar?.type;
  const type = messagebar?.type;
  const message = messagebar?.message;
  const show = messagebar?.show;

  const handleClose = () => {
    dispatch(hideMessageBar());
  };
  if (message && type) {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={show}
        autoHideDuration={5000}
        onClose={handleClose}
        TransitionComponent={Slide}
      >
        <Alert onClose={handleClose} severity={type}>
          <AlertTitle style={{ textTransform: "uppercase", fontWeight: 700, fontFamily: 'Manrope' }} fontSize={14}>{title}</AlertTitle>
          <Typography style={{ fontFamily: 'Manrope' }} fontSize={16}>
            {message}
          </Typography>
        </Alert>
      </Snackbar>
    );
  }
  return <></>
}